import { motion } from "framer-motion";

const lines = [
  { text: "$ ais verify anchor --decision dec_8f2a91", cls: "text-zinc-100" },
  { text: "→ hashing decision payload ....... sha256:9c1e44ab…f207", cls: "text-zinc-500" },
  { text: "→ model: compliance-assistant@2.4.1", cls: "text-zinc-500" },
  { text: "→ inputs: 3 documents · 1 policy graph · reviewer: j.chen", cls: "text-zinc-500" },
  { text: "→ anchoring to L2 ................ tx 0x8f2a…e91c", cls: "text-zinc-500" },
  { text: "✓ anchored in block 21,847,203 (finality: 12s)", cls: "text-cyan-400" },
  { text: " ", cls: "" },
  { text: "$ ais verify proof --tx 0x8f2a…e91c", cls: "text-zinc-100" },
  { text: "→ recomputing merkle path ........ 14 nodes", cls: "text-zinc-500" },
  { text: "✓ proof valid — decision is tamper-evident", cls: "text-cyan-400" },
  { text: "✓ exportable: auditor_bundle.json (regulator-ready)", cls: "text-blue-400" },
];

const TerminalSnippet = () => (
  <div data-testid="terminal-snippet" className="overflow-hidden border border-white/10 bg-black">
    <div className="flex items-center justify-between border-b border-white/10 bg-[#0A0A0A] px-5 py-3">
      <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">ais-cli — verify engine</span>
      <div className="flex gap-1.5">
        <span className="h-2.5 w-2.5 rounded-full bg-zinc-700" />
        <span className="h-2.5 w-2.5 rounded-full bg-zinc-700" />
        <span className="h-2.5 w-2.5 rounded-full bg-cyan-400 pulse-node" />
      </div>
    </div>
    <div className="p-6 font-mono text-[13px] leading-7 sm:px-8">
      {lines.map((l, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: -8 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ delay: i * 0.18, duration: 0.35 }}
          className={l.cls}
        >
          {l.text}
        </motion.div>
      ))}
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: lines.length * 0.18 }}
        className="mt-1 inline-block h-4 w-2 bg-cyan-400 pulse-node align-middle"
      />
    </div>
  </div>
);

export default TerminalSnippet;
